import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "https://moga-dev.com/api/products/home";

export const fetchAllProducts = createAsyncThunk("products/fetchAll", async () => {
  const response = await axios.get(`${BASE_URL}`);
  return response.data.data;
});

export const fetchTop8Products = createAsyncThunk("products/fetchTop8", async () => {
  const response = await axios.get(`${BASE_URL}`);
  return response.data.data.filter(product => product.most_selling === 1).slice(0, 8);
});

export const fetchAllTopSellingProducts = createAsyncThunk("products/fetchAllTopSelling", async () => {
  const response = await axios.get(`${BASE_URL}`);
  return response.data.data.filter(product => product.most_selling === 1);
});

export const fetchTenProducts = createAsyncThunk("products/fetchTen", async () => {
  const response = await axios.get(`${BASE_URL}`);
  return response.data.data.slice(0, 8);
});

export const fetchSortedAllProducts = createAsyncThunk(
  "products/fetchSortedAll",
  async (sortId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/${sortId}`);
      return { sortId, sortedProducts: response.data.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch sorted products");
    }
  }
);

export const fetchSortedTopSellingProducts = createAsyncThunk(
  "products/fetchSortedTopSelling",
  async (sortId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/${sortId}`);
      return { sortId, sortedProducts: response.data.data.filter(product => product.most_selling === 1) };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch sorted top-selling products");
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState: {
    allProducts: [],
    top8Products: [],
    allTopSellingProducts: [],
    tenProducts: [],
    sortedAllProducts: {}, 
    sortedTopSellingProducts: {}, 
    loading: false,
    error: null,
    sortedLoading: false,
    sortedError: null,
    sortedTopSellingLoading: false, 
    sortedTopSellingError: null, 
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.allProducts = action.payload;
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTop8Products.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTop8Products.fulfilled, (state, action) => {
        state.loading = false;
        state.top8Products = action.payload;
      })
      .addCase(fetchTop8Products.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllTopSellingProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTopSellingProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.allTopSellingProducts = action.payload;
      })
      .addCase(fetchAllTopSellingProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTenProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTenProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.tenProducts = action.payload;
      })
      .addCase(fetchTenProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSortedAllProducts.pending, (state) => {
        state.sortedLoading = true;
        state.sortedError = null;
      })
      .addCase(fetchSortedAllProducts.fulfilled, (state, action) => {
        const { sortId, sortedProducts } = action.payload;
        state.sortedLoading = false;
        state.sortedAllProducts[sortId] = sortedProducts;
      })
      .addCase(fetchSortedAllProducts.rejected, (state, action) => {
        state.sortedLoading = false;
        state.sortedError = action.error.message;
      })

      .addCase(fetchSortedTopSellingProducts.pending, (state) => {
        state.sortedTopSellingLoading = true;
        state.sortedTopSellingError = null;
      })
      .addCase(fetchSortedTopSellingProducts.fulfilled, (state, action) => {
        const { sortId, sortedProducts } = action.payload;
        state.sortedTopSellingLoading = false;
        state.sortedTopSellingProducts[sortId] = sortedProducts;
      })
      .addCase(fetchSortedTopSellingProducts.rejected, (state, action) => {
        state.sortedTopSellingLoading = false;
        state.sortedTopSellingError = action.error.message;
      });
  },
});

export default productSlice.reducer;
